module.exports = __webpack_public_path__ + "static/media/178352.64c75d91.jpg";